<h1 mat-dialog-title>
    <span>
        <mat-icon class="generic-icon" style="color: {{ data.iconColor }}">{{data.icon}}</mat-icon>
        <span class="header-text">{{data.title}}</span>
    </span>
</h1>
<mat-dialog-content>
    <p *ngFor="let line of data.message; trackBy: trackBy">{{line}}</p>
    <ng-container *ngIf="data.primaryButtonAction != null">
        <mat-grid-list [cols]="numberOfButtons" rowHeight="60px">
            <mat-grid-tile colspan="1">
                <button mat-raised-button [color]="data.primaryButtonColor" (click)="data.primaryButtonAction()" mat-dialog-close>{{data.primaryButtonText != null ? data.primaryButtonText : "Doorgaan"}}</button>
            </mat-grid-tile>
            <ng-container *ngIf="data.secondaryButtonAction != null">
                <mat-grid-tile colspan="1">
                <button mat-raised-button [color]="data.secondaryButtonColor" (click)="data.secondaryButtonAction()" mat-dialog-close>{{data.secondaryButtonText != null ? data.secondaryButtonText : "Annuleren"}}</button>
                </mat-grid-tile>
            </ng-container>
        </mat-grid-list>
    </ng-container>
</mat-dialog-content>
